import React, { ReactElement, ReactNode } from "react"

import { Checkbox, CheckboxProps, FormControlLabel, styled } from "@mui/material"
import { CheckboxPropsColorOverrides } from "@mui/material/Checkbox/Checkbox"
import { OverridableStringUnion } from "@mui/types"

import { Palette } from "@cirrus/ui-kit/src/lib/_private"
import { withPalette } from "@cirrus/ui-kit/src/lib/theme"

interface IProps extends CheckboxProps {
  label?: ReactNode
  color?: OverridableStringUnion<
    "primary" | "secondary" | "error" | "info" | "success" | "warning" | "default",
    CheckboxPropsColorOverrides
  >
}

const StyledCheckbox = styled(Checkbox)(
  ({ color, disabled }) => ({
    "&[class*='Mui-checked']": {
      "&[class*='Mui-disabled']": {
        color: "#008859",
        opacity: .5
      },
      color: withPalette(color, Palette.isSecondary(color) ? "contrastText" : "main")
    },
    color: disabled ? "#bdbdbd" : "#757575",
    height: "40px"
  })
)

const StyledFormControlLabel = styled(FormControlLabel)(
  ({ disabled, theme }) => ({
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    margin: 0,

    "& .MuiTypography-root": {
      // @ts-ignore
      color: disabled ? "#bdbdbd" : theme.typography.color,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 700
    }
  }))


export const LabeledCheckbox = ({ color = "primary", ...props }: IProps): ReactElement => {

  if (!props.label) {
    return <StyledCheckbox
      {...props}
      color={color}
    />
  }

  return (
    <StyledFormControlLabel
      control={<StyledCheckbox
        {...props}
        color={color} />}
      label={props.label}
    />
  )
}


